
<script>
import moment from 'moment'
import {
  RexSelect,
  RexDate,
  RexTourists,
  RexInput,
  RexDurations
} from '@/components/views/rexFieldsV2'
import {
  cloningAnObject,
  nToWord
} from '@/utils/helpers'

export default {
  name: 'accommodations-form',
  components: {
    RexSelect,
    RexDate,
    RexTourists,
    RexInput,
    RexDurations
  },
  props: {
    hotelId: {
      type: Number,
      default: () => null
    },
    isLocked: {
      type: Boolean,
      default: () => false,
    },
    hotelIndex: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    currentForm: {},
  }),
  computed: {
    rooms() {
      return this.$store.getters['cart/getHotelForm'](this.hotelIndex).rooms
    },
    accommodations() {
      return this.$store.getters['cart/getHotelAccommodations'](this.hotelIndex)
    },
    meals() {
      return this.$store.getters['cart/getHotelFilters'](this.hotelIndex).meals
    },
    mainServiceIsTours() {
      return this.$store.getters['cart/getMainService'] === 'tours'
    }
  },
  created() {
    this.currentForm = cloningAnObject(this.$store.getters['cart/getHotelForm'](this.hotelIndex))
  },
  methods: {
    search() {
      this.$parent.formIsShown = false

      this.$store.commit('cart/setTourists', {
        numberOfTourists: this.$store.getters['cart/getNumberOfTourists'].total
      })

      this.$store.commit('cart/updateServiceModuleIsLoading', {
        status: true,
        target: `hotels.${this.hotelIndex}.accommodations`
      })

      this.$store.dispatch('cart/getHotelAccommodations', {
        hotelId: this.hotelId,
        hotelIndex: this.hotelIndex,
        form: {
          ...this.$store.getters['cart/getHotelFormForSearch'](this.hotelIndex)
        }
      })
    },
    closeWithoutSaving() {
      this.$parent.formIsShown = false

      this.$store.commit('cart/setServiceFullForm', {
        target: `hotels.${this.hotelIndex}`,
        form: this.currentForm
      })
    },
    addRoom() {
      this.$store.commit('cart/updateServiceField', {
        target: `hotels.${this.hotelIndex}.form.rooms`,
        value: [
          ...this.rooms,
          {
            adults: 1,
            children: 0,
            ages: []
          }
        ]
      })
    },
    removeRoom(roomIndex) {
      const rooms = cloningAnObject(this.rooms)
      rooms.splice(roomIndex, 1)

      this.$store.commit('cart/updateServiceField', {
        target: `hotels.${this.hotelIndex}.form.rooms`,
        value: rooms
      })
    },
    durationFormat: duration => `${duration} ${nToWord(duration, ['ночь', 'ночи', 'ночей'])}`,
    formatDate: date => moment.unix(date).format('DD.MM.YYYY')
  }
}
</script>

<template>
  <div class="cart__hotel-accommodations-form">
    <div class="cart__hotel-accommodations-form-content">
      <div
        v-if="mainServiceIsTours"
        class="cart__hotel-accommodations-form-row"
      >
        <rex-input
          label="дата заезда"
          name="startDate"
          store-module="cart"
          getter="getServiceField"
          setter="updateServiceField"
          :target="''"
          :value="formatDate(accommodations.current.startDate)"
          :is-disabled="true"
        />
        <rex-input
          label="длительность"
          name="duration"
          store-module="cart"
          getter="getServiceField"
          setter="updateServiceField"
          :target="''"
          :value="durationFormat(accommodations.current.duration)"
          :is-disabled="true"
        />
      </div>
      <div
        v-else
        class="cart__hotel-accommodations-form-row"
      >
        <rex-date
          label="дата заезда"
          :name="`${hotelIndex}_checkInDate`"
          store-module="cart"
          getter="getServiceField"
          setter="updateServiceField"
          :target="`hotels.${hotelIndex}.form.checkInDate`"
          :is-disabled="isLocked"
        />
        <rex-durations
          label="длительность"
          :name="`${hotelIndex}_duration`"
          store-module="cart"
          getter="getServiceField"
          setter="updateServiceField"
          :target="`hotels.${hotelIndex}.form.duration`"
          :is-disabled="isLocked"
        />
        <rex-tourists
          label="Взрослые, дети"
          :name="`${hotelIndex}_rooms`"
          store-module="cart"
          getter="getServiceField"
          setter="updateServiceField"
          :target="`hotels.${hotelIndex}.form.rooms`"
          :is-disabled="isLocked"
        />
        <rex-select
          label="Питание"
          :name="`${hotelIndex}_meals`"
          store-module="cart"
          getter="getServiceField"
          setter="updateServiceField"
          :target="`hotels.${hotelIndex}.form.meals`"
          :options="meals"
          :is-multiple="true"
          :is-disabled="isLocked"
          :hide-if-empty="false"
        />
        <div
          v-if="!isLocked"
          class="cart__hotel-accommodations-form-button-wrap"
        >
          <b-button
            class="rex-button2"
            type="is-primary"
            expanded
            @click="search"
          >
            Найти
          </b-button>
        </div>
      </div>
    </div>
    <p class="cart__hotel-accommodations-form-info">
      <span>Внимание!</span> При изменении состава туристов все дополнительные услуги в туре
      будут пересчитаны/сброшены. Проверяйте состав тура!
    </p>
  </div>
</template>
